'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fileAttachmentIdsForThreadFromProps = undefined;

var _reselect = require('reselect');

var _fileAttachmentIdsInHistory = require('conversations-schema/thread-history/operators/fileAttachmentIdsInHistory');

var _historyDataForThread = require('../../thread-histories/selectors/historyDataForThread');

var fileAttachmentIdsForThreadFromProps = exports.fileAttachmentIdsForThreadFromProps = (0, _reselect.createSelector)([_historyDataForThread.historyDataForThread], function (threadHistory) {
  return (0, _fileAttachmentIdsInHistory.fileAttachmentIdsInHistory)(threadHistory);
});